import store from './store';
import { updateStatuses } from './statuses';
import { fetchImageDestinationLocations, fetchImages , fetchClones, fetchAgents } from './actions/manageModeActionCreators';
import { fetchBackupLocations } from './actions/backupLocationActionCreators';
import { fetchSqlServerInstances } from './actions/sqlServerInstanceActionCreators';
import { fetchLicence } from './actions/licenceActionCreators';
import { fetchMe } from './actions/userActionCreators';

// This must be kept in sync with what is fetched in initialFetch.
const updateables = ['agents', 'sqlServerInstances', 'backupLocations', 'imageDestinationLocations', 'images', 'clones'];

let hasEverFullyLoaded = false;

export function isLoading(state) {
    if (hasEverFullyLoaded) return {
        isFaulted: false,
        isLoaded: true
    };
    let isFaulted = false;
    let isLoaded = true;
    let error = null;
    for (const key of updateables) {
        const updateable = state[key];
        if (updateable.updateStatus === updateStatuses.failure) {
            console.log('Not loaded because ' + key + ' failed to load');
            isLoaded = false;
            isFaulted = true;
            error = updateable.error;
            break;
        }
        if (updateable.updateStatus !== updateStatuses.success) {
            console.log('Not loaded because ' + key + ' is in state ' + updateable.updateStatus);
            isLoaded = false;
            break;
        }
    }
    if (!store.hydrated) {
        if (isLoaded) {
            console.log('Not loaded because store is not hydrated');
        }
        isLoaded = false;
    }
    hasEverFullyLoaded = isLoaded;
    return {
        isFaulted: isFaulted,
        isLoaded: isLoaded,
        error: error
    };
}

export function initialFetch() {
    store.dispatch(fetchMe());
    store.dispatch(fetchLicence());
    store.dispatch(fetchAgents());
    store.dispatch(fetchSqlServerInstances());
    store.dispatch(fetchBackupLocations());
    store.dispatch(fetchImageDestinationLocations());
    store.dispatch(fetchImages());
    store.dispatch(fetchClones());
};



// WEBPACK FOOTER //
// ./src/js/initialFetch.js